import { useEffect, useRef } from "react";

const COLORS = ["#FF8E9E", "#B5D5C5", "#DDA77B", "#FFD166", "#F9C6CF"];

export const SparkleCursor = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let w = 0;
    let h = 0;
    let raf;
    const parts = [];
    let last = 0;

    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    resize();

    const onMove = (e) => {
      const now = performance.now();
      if (now - last < 26) return;
      last = now;
      for (let i = 0; i < 3; i++) {
        parts.push({
          x: e.clientX,
          y: e.clientY,
          vx: (Math.random() - 0.5) * 2.6,
          vy: (Math.random() - 0.5) * 2.6 - 0.7,
          size: 3 + Math.random() * 4,
          color: COLORS[(Math.random() * COLORS.length) | 0],
          life: 1,
          decay: 0.012 + Math.random() * 0.016,
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.22,
          rect: Math.random() > 0.45,
        });
      }
      if (parts.length > 240) parts.splice(0, parts.length - 240);
    };

    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (let i = parts.length - 1; i >= 0; i--) {
        const p = parts[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.05;
        p.rot += p.vr;
        p.life -= p.decay;
        if (p.life <= 0) {
          parts.splice(i, 1);
          continue;
        }
        ctx.save();
        ctx.globalAlpha = Math.max(p.life, 0);
        ctx.fillStyle = p.color;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        if (p.rect) {
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.55);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMove);
    tick();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  return (
    <canvas
      data-testid="sparkle-cursor-canvas"
      ref={ref}
      className="fixed inset-0 z-[95] pointer-events-none"
      aria-hidden="true"
    />
  );
};
